import createExpressCheckingForm from './createExpressCheckingFormModel';
const {
  formField: {
    // DATOS AREA
    code,
    adults,
    minors,
    arrival,
    departure,
    bussines,
  },
} = createExpressCheckingForm;

export default {
  [code.name]: '',
  [adults.name]: '',
  [minors.name]: 0,
  [arrival.name]: null,
  [departure.name]: null,
  [bussines.name]: false,
};
